export const DEFAULT = '';
export const Address = {
  houseNo: '',
  address01: '',
  address02: '',
  town: '',
  country: '',
  postCode: '',
};
